import { ConfigurationMetadataDto } from '../../types/ExperimentData'
import { MetaDataTableRow } from '../../types/metaDataTableRows'
import { prettifyString } from '../string/prettifyString'
import { statusMapper } from './statusMapper'

export const mapMetaDataToRow = (data: ConfigurationMetadataDto): MetaDataTableRow => ({
    id: data.id,
    expId: data.experiment.id,
    name: data.experiment.name,
    domain: data.domain,
    startDate: new Date(data.startDate),
    endDate: new Date(data.endDate),
    status: statusMapper(new Date(data.startDate), new Date(data.endDate), data.live, data.archived),
    type: prettifyString(data.experiment.type),
    slots: data.availableSlots,
    dashboard: data.experiment.name,
})
